import { type EmojiId } from '../emoji/emoji';
import { type User } from '../user/user';

export type CartEid = {
    emoji_id: EmojiId;
    redemption_code?: string;
};

export interface ReplaceCart {
    items: CartEid[];
}

export interface UpdateCart {
    items: CartEid[];
}

export type MethodTypesV2 = 'Stripe' | 'Globee' | 'Cash' | 'Free' | 'CoinbaseCommerce';
export type MethodProviders = 'Stripe' | 'Globee';

export type CryptoPaymentData = {
    title: string;
    amount: number;
    address: string;
    currency: string;
};

export interface CheckoutMethodV2 {
    method: MethodTypesV2;
    success_url?: string;
    cancel_url?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tracking_data?: any; // TODO add actual type
    pubkey?: string;
    amount?: number;
    external_reference?: number;
}

export type OrderItemTypes = 'EmojiId' | 'Discount';

export type OrderItems = {
    client_fee_in_cents: number;
    company_fee_in_cents: number;
    created_at: string;
    emoji_id: EmojiId;
    id: string;
    item_type: OrderItemTypes;
    order_id: string;
    quantity: number;
    unit_price_in_cents: number;
    updated_at: string;
    code_id: string;
    marked_invalid_at: string;
    parent_id: string;
    refunded_quantity: number;
    rhythm_score: number;
};

export type PaymentMethodDataV2 = {
    client_secret: string;
    invoice_id: string;
    method: MethodTypesV2;
    payment_intent_id: string;
    session_id: string;
    methods: CryptoPaymentData[];
};

export type OrderId = string;

export enum CartStatus {
    Draft = 'Draft',
    Paid = 'Paid',
    PendingPayment = 'PendingPayment',
}

export interface CartResponse {
    checkout_url: string | undefined;
    checkout_url_expires_at: string | undefined;
    created_at: string;
    expires_at: string;
    id: OrderId;
    order_items: OrderItems[];
    order_number: string;
    organization_id: string | undefined;
    paid_at: string | undefined;
    payment_method_data: PaymentMethodDataV2;
    seconds_until_expiry: number;
    status: CartStatus;
    total_in_cents: number;
    remaining_due_in_cents: number;
    updated_at: string;
    user: User;
    user_id: string;
    error?: string;
}

export interface CheckoutResponseV2 {
    created_at: string;
    eligible_for_refund: boolean;
    expires_at: string;
    id: string;
    misc_refunded_total_in_cents: number;
    order_items: Array<OrderItems>;
    order_number: string;
    organization_id: string;
    paid_at: string;
    payment_method_data: PaymentMethodDataV2;
    refunded_total_in_cents: number;
    seconds_until_expiry: number;
    status: string;
    total_in_cents: number;
    updated_at: string;
    user: User;
    user_id: string;
}
